import { Typography } from '@mui/material';
import { getEnvVar } from 'utils/env';
import GrafanaPanel from './GrafanaPanel';

const DASHBOARD_UID = 'galaxy_last_user_login';
const PANEL_ID = 1;

interface RecentLoginsTabProps {
  teamId: number;
  isFetchingTeamMembers?: boolean;
  tenant?: string;
  realmId?: string;
}

const RecentLoginsTab = ({ teamId, tenant, realmId }: RecentLoginsTabProps) => {
  // Capitalize the environment name to match Grafana's template variable values (e.g. "Party", "Prod")
  const uiEnv = getEnvVar('UI_ENV') || '';
  const env = uiEnv ? uiEnv.charAt(0).toUpperCase() + uiEnv.slice(1).toLowerCase() : '';

  // Build variables only when all required context is available
  const variables =
    tenant && realmId && env ? { env, tenant, realm: realmId, teamId: String(teamId) } : undefined;

  return (
    <GrafanaPanel
      dashboardUid={DASHBOARD_UID}
      panelId={PANEL_ID}
      variables={variables}
      alt="Recent user logins panel"
      minHeight="600px"
      missingContext={
        <Typography
          sx={{
            color: 'text.secondary',
          }}
        >
          Tenant, realm, and environment context required to load login data.
        </Typography>
      }
      empty={
        <Typography
          sx={{
            color: 'text.secondary',
          }}
        >
          No login data available for this realm.
        </Typography>
      }
      renderError={(message) => (
        <Typography color="error">Failed to load recent logins: {message}</Typography>
      )}
    />
  );
};

export default RecentLoginsTab;
